__turbopack_context__.v({
  "chevron": "aeMw5W_chevron",
  "content": "aeMw5W_content",
  "control": "aeMw5W_control",
  "icon": "aeMw5W_icon",
  "item": "aeMw5W_item",
  "label": "aeMw5W_label",
  "labelText": "aeMw5W_labelText",
  "rightSection": "aeMw5W_rightSection",
  "root": "aeMw5W_root",
});
